import styled, { css } from 'styled-components';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
import { FocusShadow, FocusStyles } from '../../styles/FocusStyles';
import { colors } from '../themes/colors';
export const TagLabelStyles = css `
  font-family: ${props => props.theme.fonts.serif};
  font-size: 0.8125rem;
  padding: 0.3125rem 0.725rem;
  border: none;
  border-radius: 0.9375rem;
  white-space: nowrap;
`;
export const RadioLabel = styled.label `
  cursor: pointer;
  ${FocusStyles}
`;
export const TagContent = styled.span `
  ${({ backgroundColor, color }) => css `
    ${TagLabelStyles}
    color: ${colors[color]};
    background-color: ${colors[backgroundColor]};
  `}
`;
// Hidden visually
export const TagRadio = styled.input `
  ${AssistiveTechnologyOnly};

  /* Using FocusStyles not possible here because of the added label selector */
  @supports not (selector(:focus-visible)) {
    &.focus-visible,
    &:focus + label {
      ${FocusShadow}
    }
  }

  @supports selector(:focus-visible) {
    &:focus-visible + label {
      ${FocusShadow}
    }
  }
`;
export const TagWrapper = styled.span `
  display: block;
  margin: 0.5rem 0;
  width: fit-content;
  position: relative;

  Link,
  a {
    ${FocusStyles}
    text-decoration: none;
    border-radius: 0.9375rem;
    /* small padding used to show the focus styles appropriate */
    padding: 1px 1px 3px 1px;
    cursor: pointer;
  }
`;
